import { DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import { ArrowForward } from '@mui/icons-material';
import ChLink from '@rhg/components/ch-link';
import { Box, Button, ButtonProps, SxProps } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { routes } from '@rhg/utils/routes';

interface ViewAllCategoryButtonProps {
    label: string;
    packClass: string;
    containerSx?: SxProps;
    buttonProps?: ButtonProps;
}

const styleCategoryButtonContainer = {
    display: 'flex',
    justifyContent: 'center',
    my: DS_SPACING_UNITS.SECTION,
};

export const ViewAllCategoryButton = ({
    label,
    packClass,
    containerSx,
    buttonProps,
}: ViewAllCategoryButtonProps) => {
    return (
        <Box sx={sxAppend(styleCategoryButtonContainer, containerSx)}>
            <ChLink href={routes.discoverPack(packClass, true)}>
                <Button
                    trackButton="ViewAllCategory"
                    variant="text"
                    endIcon={<ArrowForward />}
                    {...buttonProps}
                >
                    {label}
                </Button>
            </ChLink>
        </Box>
    );
};
